import styled from 'styled-components';

const Button = styled.button`
	color : white;
	appearance : none;
	font-size : 14px;
	border: 0px solid white;
	border-radius: 25px;
	text-align : center;
	margin: 5px;
	font-family: 'sans-serif';
	
	${props => {
		switch (props.bg) {
			case 'green':
				return `background: ${props.theme.green};`;
			case 'purple':
				return `background: ${props.theme.purple};`;
			default: 
				return `background: ${props.theme.green};`;
		}
	}}
	${props => {
		if (props.padding) {
			return `padding: ${props.padding};`;
		} else {
			return `padding: 10px;`;
		}
	}}
	&:hover {
		cursor: pointer;
	}
`;

export default Button;